import { createFileRoute, redirect } from '@tanstack/react-router';

// Deadlines tab removed in FIP-001 — replaced by Obligation Bar (FIP-002).
// Redirect to finance root so existing deep links don't break.
export const Route = createFileRoute('/admin/finance/deadlines')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/finance' });
  },
});
